module.exports = __webpack_public_path__ + "media/images/badge/supercoppa-vincente-7a7c0bc17b3afd93085f356fc36091ac.png";